import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-skills-modal',
  templateUrl: './skills-modal.component.html',
  styleUrl: './skills-modal.component.scss'
})
export class SkillsModalComponent {
  @Input() name: string = '';
  @Input() matchedSkills: string[] = [];
  @Input() unmatchedSkills: string[] = [];

  constructor(public activeModal: NgbActiveModal) {}
}
